import {Injectable, inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';

const CANONICAL_REL = 'canonical';

@Injectable({providedIn: 'root'})
export class SeoService {
  private _title: Title = inject(Title);
  private _meta: Meta = inject(Meta);
  private _document: Document = inject(DOCUMENT);

  public setPage(title: string, description: string): void {
    const url: string = `${window.location.origin}${window.location.pathname}`;

    this._title.setTitle(title);
    this._meta.updateTag({name: 'description', content: description});
    this._meta.updateTag({property: 'og:title', content: title});
    this._meta.updateTag({property: 'og:description', content: description});
    this._meta.updateTag({property: 'og:url', content: url});
    this._setCanonicalLink(url);
  }

  private _setCanonicalLink(url: string): void {
    let link: HTMLLinkElement | null = this._document.querySelector(`link[rel="${CANONICAL_REL}"]`);
    if (!link) {
      link = this._document.createElement('link');
      link.setAttribute('rel', CANONICAL_REL);
      this._document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
